<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title">{{ getModalTitle }}</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="modal-form">
          <form @submit.prevent="onSubmit">
            <div class="form-group row" v-if="statusType == 'Inactivate'">
                <div class="col-12">
                    <div class="custom-control custom-checkbox" v-for="(option, tindex) in inactivation_options" :key="tindex">
                        <input 
                            type="checkbox" 
                            class="custom-control-input" 
                            name="Reason"
                            v-bind:id="'reason_' + tindex"
                            v-bind:value="option.value"
                            v-validate="'required'"
                            :checked="isChecked"
                            v-model="reasons"
                            @click="getSelectedOption(option.value, $event)">
                        <label class="custom-control-label" :for="'reason_' + tindex">{{ option.name }}</label>
                    </div>
                    <div v-show="verrors.has('Reason')" class="validate-warning-msg">{{ verrors.first('Reason') }}</div>
                </div>
            </div>
            <div class="form-group row" v-if="statusType == 'Activate'">
                <div class="col-12">
                    <div class="custom-control custom-checkbox" v-for="(option, tindex) in activation_options" :key="tindex">
                        <input 
                            type="checkbox" 
                            class="custom-control-input" 
                            name="Reason"
                            v-bind:id="'ac_reason_' + tindex"
                            v-bind:value="option.value"
                            v-validate="'required'"
                            :checked="isChecked"
                            v-model="reasons"
                            @click="getSelectedOption(option.value, $event)">
                        <label class="custom-control-label" :for="'ac_reason_' + tindex">{{ option.name }}</label>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-12">
                    <textarea 
                    name="Comment for mentee"
                    class="form-control"
                    v-model="other_reasons"
                    placeholder='Enter text for "Other"'
                    maxLength="180">
                    </textarea>
                </div>
            </div>
            <div class="text-center pad-20">
                <button type="submit" class="btn btn-sm btn-blue confirmBtn text-center">Confirm</button>
            </div>
          </form>
        </div>
      </div>
     </div>
</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: ['isModalVisible'],
  data() {
    return {
      menteeId: this.$route.params.mentee_id,
      statusType: '',
      activation_options: [
        {
        'value': 'Employee was re-hired',
        'name': 'Employee was re-hired',
        },
        {
        'value': 'Employee re-joined apprenticeship program',
        'name': 'Employee re-joined apprenticeship program',
        },
        {
        'value': 'Returned from medicalillness leave',
        'name': 'Returned from medicalillness leave',
        },
        {
        'value': 'Other',
        'name': 'Other',
        },
    ],
    inactivation_options: [
        {
        'value': 'No longer works here',
        'name': 'No longer works here',
        },
        {
        'value': 'Quit apprenticeship program',
        'name': 'Quit apprenticeship program',
        },
        {
        'value': 'Medical/Illness leave',
        'name': 'Medical/Illness leave',
        },
        {
        'value': 'Moved to different apprentice program employer',
        'name': 'Moved to different apprentice program employer',
        },
        {
        'value': 'Other',
        'name': 'Other',
        },
    ],
    other_reasons: '',
    reasons: [],
    isChecked: false,
    }
  },
  computed: {
      getModalTitle(){
          if (this.statusType == 'Inactivate') {
              return 'Confirm Inactivation';
          } else {
              return 'Confirm Re-activation';
          }
      }
  },
  methods: {
    navigate() {
      this.$router.push(this.$router.currentRoute.path)
      this.$router.go();
    },
    closeModal() {
      this.$validator.errors.clear();
      this.$emit('close');
      this.navigate();
    },
    getItem(type) {
        this.statusType = type;
    },
    getSelectedOption(reasonValue, event) {
        if(event.target.checked == true) {
            this.reasons.push(reasonValue);
        }
        else {
            const removeItem = reasonValue;
            const removeItemIndex = this.reasons.indexOf(removeItem);
            this.reasons.splice(removeItemIndex, 1); 
        }
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
          if(!result) {
            return;
          }
          this.updateActivationStatus();
      }).catch(() => {
          // catches the error;
      });
    },
    updateActivationStatus() {
        if(this.reasons.indexOf('Other') > -1) {
            if(this.other_reasons == '') {
                alert("Please enter text for other");
                return false;
            }
        }
        axios.post('/mobile/mentee-status-edit', {
          reasons: this.reasons,
          other_reasons: this.other_reasons,
          type: this.statusType,
          mentee_id: this.menteeId,
          account_id: this.$store.state.user_accountid,
        })
        .then(response =>  {
          this.closeModal();       
       })
       .catch((error) => {
          console.log(error)
       });
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
}
.modal-container {
  width: 500px;
  margin: 40px auto 0;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  font-size: 14px;
  font-weight: 900;
}
.modal-form {
  font-size: 13px;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.confirmBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;
}
/* Small Devices */
@media (min-width: 375px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
    margin: 120px auto; 
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manager/edit_mentee_account_status.vue